import React, { useCallback, useMemo } from 'react'

import { CustomDropdownItemOption, DropDownItemOptionComponentProps, SelectDropdown } from '../../../components/SelectDropdown/SelectDropdown'
import { useInPersonMeetingApp } from '../InPersonMeetingProvider.shared'

export type MediaDeviceSelectorProps = {
  disabled?: boolean
}
export const MediaDeviceSelector: React.FC<MediaDeviceSelectorProps> = ({ disabled = false }) => {
  const { audioInputDevices, changeAudioDeviceId, currentAudioDeviceId } = useInPersonMeetingApp()
  const options = useMemo(() => {
    return audioInputDevices?.map(({ deviceId: id, label }) => ({ id, label })) ?? []
  }, [audioInputDevices])

  const MediaDeviceDropdownItemOption: React.FC<DropDownItemOptionComponentProps> = useCallback(
    ({ optionId, optionLabel, onClick }) => {
      const showTag = currentAudioDeviceId === optionId

      return (
        <CustomDropdownItemOption role='button' onClick={onClick} className='d-flex gap-2 align-items-center'>
          {optionLabel}
          {showTag ? <span className='zocks-text-primary fw-medium paragraph-small'>Current</span> : null}
        </CustomDropdownItemOption>
      )
    },
    [currentAudioDeviceId],
  )

  const selectedOption = useMemo(() => {
    const device = options.find(({ id }: { id: string }) => id === currentAudioDeviceId)
    return device ?? options[0]
  }, [options, currentAudioDeviceId])

  return (
    <div>
      {audioInputDevices?.length ? (
        <SelectDropdown
          disabled={disabled}
          className='zocks-py-0.375 zocks-px-0.75 media-device-selector'
          options={options}
          icon='bi-mic'
          initialSelectedOption={selectedOption}
          onOptionSelected={(option) => changeAudioDeviceId(option.id)}
          DropDownItemOptionComponent={MediaDeviceDropdownItemOption}
        />
      ) : (
        <div className='skeleton' style={{ width: '100%', height: '60px' }} />
      )}
    </div>
  )
}
